var _rect, _rect2, _path, _path2, _path3, _rect3, _rect4, _path4, _path5, _path6, _rect5, _rect6, _path7, _path8, _path9, _rect7, _rect8, _path0, _path1, _path10, _path11, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _rect9, _path12, _path13, _path14, _path15, _rect0, _rect1, _path16, _path17, _path18, _rect10, _rect11, _path19, _path20, _path21, _rect12, _rect13, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectiveCarFreeDays(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 141,
    viewBox: "0 0 292 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.15846,
    y: -0.81116,
    width: 42,
    height: 42,
    rx: 21,
    transform: "matrix(-0.984808 -0.173648 -0.173648 0.984808 210.496 10.1342)",
    fill: "#2F6FEB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.15846,
    y: -0.81116,
    width: 42,
    height: 42,
    rx: 21,
    transform: "matrix(-0.984808 -0.173648 -0.173648 0.984808 210.496 10.1342)",
    stroke: "#E6EFFF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M178.394 13.6484L189.671 38.2887",
    stroke: "white",
    strokeWidth: 1.53846,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.836 15.8167L184.055 16.2079L189.256 17.125L192.392 17.678C193.054 17.7947 193.366 18.4525 193.515 19.1077L194.482 23.3437C195.823 25.5327 195.637 26.5892 195.459 27.607C195.447 27.6731 195.435 27.7391 195.424 27.8051C195.424 27.809 195.423 27.8129 195.423 27.8167C195.422 27.8208 195.422 27.8249 195.421 27.829L195.406 27.9153L195.23 28.9139C195.028 30.0584 194.502 31.0654 193.663 31.6925L193.099 34.8932C193.008 35.4098 192.519 35.7523 192.002 35.6612L191.225 35.5241C190.708 35.433 190.365 34.9438 190.456 34.4272L190.937 31.7006L188.763 31.3171L184.736 22.306C185.104 22.3556 185.446 22.4073 185.747 22.4606C187.93 22.8475 192.197 24.0882 192.197 24.0882C192.502 24.1422 192.896 23.94 192.845 23.634L192.289 20.2703C192.238 19.9643 192.14 19.6755 191.835 19.6217L182.827 18.0333L181.836 15.8167Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.112 30.8518L177.536 29.3397L177.056 32.0663C176.965 32.5829 176.475 32.9255 175.959 32.8344L175.181 32.6972C174.664 32.6061 174.322 32.117 174.413 31.6003L174.969 28.446C174.365 27.5622 174.204 26.4136 174.41 25.2449L174.586 24.2463C174.588 24.2379 174.589 24.2303 174.591 24.2218L174.601 24.16C174.606 24.1346 174.611 24.1097 174.617 24.0848C174.619 24.0773 174.62 24.0697 174.622 24.0622C174.637 23.9867 174.651 23.9125 174.664 23.8395C174.877 22.7053 175.039 21.8418 177.018 20.2663L179.375 16.6163C179.446 16.5055 179.524 16.3967 179.607 16.2943L180.342 17.9385C180.294 18.001 180.251 18.0706 180.21 18.1424L178.517 21.1096C178.363 21.3789 178.665 21.7045 178.971 21.7582C178.971 21.7582 180.468 21.8599 182.166 22.0215L186.112 30.8518Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 180.577,
    y: 40.9166,
    width: 42,
    height: 42,
    rx: 21,
    transform: "rotate(5 180.577 40.9166)",
    fill: "#2F6FEB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 180.577,
    y: 40.9166,
    width: 42,
    height: 42,
    rx: 21,
    transform: "rotate(5 180.577 40.9166)",
    stroke: "#E6EFFF",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M209.452 53.3262L192.182 74.2081",
    stroke: "white",
    strokeWidth: 1.53846,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.565 54.5313L203.321 54.335L198.06 53.8747L194.887 53.5972C194.218 53.5386 193.746 54.0934 193.432 54.6875L191.402 58.529C189.541 60.2965 189.447 61.365 189.356 62.3943C189.35 62.4611 189.344 62.5278 189.338 62.5945C189.337 62.5984 189.337 62.6023 189.336 62.6062C189.336 62.6103 189.335 62.6143 189.335 62.6185L189.327 62.7058L189.239 63.7159C189.137 64.8736 189.385 65.9824 190.032 66.8052L189.749 70.0428C189.703 70.5655 190.087 71.0229 190.61 71.0686L191.396 71.1374C191.919 71.1832 192.376 70.7993 192.422 70.2767L192.663 67.5186L194.863 67.711L201.085 60.0491C200.717 60.0019 200.373 59.9632 200.068 59.9368C197.859 59.7454 193.417 59.8397 193.417 59.8397C193.108 59.8128 192.78 59.5155 192.908 59.2331L194.316 56.1279C194.444 55.8455 194.614 55.5919 194.923 55.619L204.035 56.4161L205.565 54.5313Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.544 67.944L206.219 68.7029L205.978 71.4611C205.932 71.9837 206.316 72.4411 206.839 72.4869L207.626 72.5557C208.148 72.6014 208.606 72.2176 208.651 71.695L208.93 68.5041C209.742 67.8068 210.196 66.739 210.299 65.5568L210.387 64.5467C210.388 64.5415 210.388 64.5366 210.389 64.5316C210.389 64.5285 210.389 64.5253 210.389 64.5219L210.395 64.4594C210.397 64.4337 210.398 64.4082 210.399 64.3827C210.4 64.375 210.4 64.3673 210.4 64.3596C210.406 64.2828 210.412 64.2076 210.417 64.1336C210.506 62.983 210.573 62.107 209.069 60.073L207.737 55.9374C207.696 55.8116 207.65 55.6864 207.596 55.5658L206.46 56.9638C206.49 57.0366 206.514 57.1152 206.535 57.1953L207.403 60.4996C207.482 60.7995 207.105 61.0357 206.796 61.0086C206.796 61.0086 205.324 60.7192 203.641 60.4357L197.544 67.944Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 74.9166,
    y: 51.6691,
    width: 66,
    height: 66,
    rx: 33,
    transform: "rotate(-5 74.9166 51.6691)",
    fill: "#2F6FEB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 74.9166,
    y: 51.6691,
    width: 66,
    height: 66,
    rx: 33,
    transform: "rotate(-5 74.9166 51.6691)",
    stroke: "#E6EFFF",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M123.212 62.6543L101.801 100.356",
    stroke: "white",
    strokeWidth: 2.46154,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.422 65.6346L113.83 65.9488L105.413 66.6852L100.337 67.1293C99.2659 67.223 98.677 68.2282 98.3474 69.2516L96.2159 75.8686C93.7741 79.1707 93.9222 80.8806 94.0649 82.5277C94.0742 82.6347 94.0834 82.7415 94.0919 82.8483C94.0925 82.8546 94.0927 82.8608 94.093 82.867C94.0933 82.8736 94.0936 82.8802 94.0941 82.8868L94.1064 83.0265L94.2478 84.6427C94.4098 86.4951 95.1072 88.1734 96.3565 89.29L96.8097 94.4703C96.8829 95.3064 97.6148 95.9206 98.4509 95.8474L99.7096 95.7373C100.546 95.6641 101.16 94.9322 101.087 94.0961L100.701 89.683L104.221 89.3751L111.895 75.5737C111.302 75.6015 110.749 75.6361 110.262 75.6791C106.728 75.9913 99.755 77.374 99.755 77.374C99.2608 77.4175 98.6612 77.0402 98.7845 76.5596L100.14 71.2756C100.264 70.7951 100.46 70.3484 100.955 70.3051L115.534 69.0296L117.422 65.6346Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.512 88.9976L122.391 87.7833L122.777 92.1964C122.85 93.0326 123.582 93.6467 124.419 93.5736L125.677 93.4634C126.513 93.3903 127.128 92.6584 127.054 91.8222L126.608 86.7168C127.693 85.3925 128.111 83.5841 127.945 81.6926L127.804 80.0764C127.803 80.0681 127.802 80.0603 127.802 80.0524C127.801 80.0473 127.801 80.0421 127.8 80.0367L127.792 79.9367C127.788 79.8956 127.783 79.8551 127.777 79.8146C127.776 79.8024 127.774 79.7901 127.772 79.7779C127.76 79.6555 127.748 79.5354 127.736 79.4171C127.556 77.5796 127.418 76.1807 124.483 73.3935L121.235 67.2471C121.137 67.0605 121.028 66.8763 120.91 66.7014L119.51 69.2197C119.577 69.3259 119.636 69.443 119.692 69.5631L121.977 74.5286C122.184 74.9793 121.657 75.4561 121.162 75.4991C121.162 75.4991 118.762 75.4524 116.032 75.4731L108.512 88.9976Z",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 142.805,
    y: 65.9327,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(4 142.805 65.9327)",
    fill: "#2F6FEB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 142.805,
    y: 65.9327,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(4 142.805 65.9327)",
    stroke: "#E6EFFF",
    strokeWidth: 2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M177.523 80.0039L157.24 105.42",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.886 81.5308L170.188 81.3422L163.866 80.9001L160.054 80.6336C159.25 80.5773 158.696 81.2528 158.332 81.9722L155.976 86.6238C153.78 88.7834 153.689 90.0674 153.602 91.3043C153.596 91.3847 153.59 91.4648 153.584 91.545C153.584 91.5497 153.583 91.5543 153.583 91.5589C153.582 91.5639 153.582 91.5688 153.581 91.5737L153.574 91.6787L153.489 92.8925C153.392 94.2837 153.711 95.6088 154.506 96.5824L154.234 100.473C154.19 101.101 154.66 101.642 155.288 101.686L156.233 101.752C156.861 101.796 157.402 101.326 157.446 100.698L157.678 97.3832L160.321 97.5681L167.625 88.2449C167.183 88.1959 166.769 88.1567 166.404 88.1315C163.749 87.9481 158.421 88.1542 158.421 88.1542C158.05 88.1284 157.65 87.7786 157.798 87.4371L159.422 83.682C159.57 83.3404 159.768 83.0326 160.139 83.0586L171.089 83.8242L172.886 81.5308Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.544 97.7918L173.968 98.5207L173.736 101.835C173.692 102.463 174.162 103.004 174.79 103.048L175.736 103.114C176.364 103.158 176.904 102.688 176.948 102.06L177.216 98.2254C178.176 97.3717 178.697 96.0811 178.797 94.6605L178.881 93.4467C178.882 93.4364 178.883 93.4272 178.884 93.4169L178.889 93.3418C178.891 93.3109 178.892 93.2803 178.892 93.2497C178.893 93.2404 178.893 93.2312 178.893 93.2219C178.898 93.1297 178.904 93.0394 178.909 92.9504C178.991 91.568 179.053 90.5156 177.206 88.1067L175.521 83.1726C175.47 83.0228 175.411 82.8737 175.344 82.7303L174.011 84.4314C174.048 84.518 174.079 84.6116 174.106 84.7071L175.216 88.6534C175.317 89.0116 174.87 89.303 174.499 89.2768C174.499 89.2768 172.726 88.9606 170.702 88.6557L163.544 97.7918Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65 83C65 81.8954 65.8954 81 67 81H87.2654C88.2607 81 89.1046 81.7319 89.2453 82.7172L92.7547 107.283C92.8954 108.268 93.7393 109 94.7346 109H195.265C196.261 109 197.105 108.268 197.245 107.283L200.755 82.7172C200.895 81.7319 201.739 81 202.735 81H223C224.105 81 225 81.8954 225 83V109V135C225 136.105 224.105 137 223 137H193H97H67C65.8954 137 65 136.105 65 135V109V83Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 120.5,
    r: 1.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 88.5,
    r: 1.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 278.5,
    cy: 23.5,
    r: 1.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 87.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 290.5,
    cy: 118.5,
    r: 1.5,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.04,
    width: 216,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 37 141)",
    fill: "#24284E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M226.5 16L239.5 8.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M229.5 55.5L247 53",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42 4L55 11",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15 45.5L33 49",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 86.8706,
    y: 4.71336,
    width: 42,
    height: 42,
    rx: 21,
    transform: "rotate(-8 86.8706 4.71336)",
    fill: "#2F6FEB"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 86.8706,
    y: 4.71336,
    width: 42,
    height: 42,
    rx: 21,
    transform: "rotate(-8 86.8706 4.71336)",
    stroke: "#E6EFFF",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M117.797 10.3105L105.667 34.5423",
    stroke: "white",
    strokeWidth: 1.53846,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.281 12.3577L112.05 12.6712L106.82 13.4062L103.667 13.8494C103.001 13.9429 102.667 14.5895 102.495 15.239L101.381 19.4387C99.9646 21.5796 100.113 22.642 100.256 23.6653C100.265 23.7318 100.274 23.7981 100.283 23.8646C100.284 23.8684 100.284 23.8723 100.285 23.8762C100.285 23.8803 100.285 23.8844 100.286 23.8885L100.298 23.9753L100.439 24.9794C100.601 26.1303 101.091 27.155 101.907 27.811L102.36 31.0294C102.433 31.5489 102.91 31.9083 103.429 31.8353L104.211 31.7254C104.731 31.6523 105.09 31.1754 105.017 30.656L104.632 27.9142L106.818 27.6069L111.156 18.7419C110.788 18.7786 110.444 18.8183 110.141 18.861C107.946 19.1714 103.639 20.2625 103.639 20.2625C103.332 20.3059 102.945 20.09 103.006 19.786L103.68 16.4437C103.741 16.1397 103.849 15.8545 104.156 15.8113L113.214 14.5384L114.281 12.3577Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.484 27.2328L118.107 26.0209L118.492 28.7626C118.565 29.2821 119.042 29.6415 119.562 29.5685L120.344 29.4586C120.863 29.3856 121.223 28.9087 121.15 28.3892L120.704 25.2173C121.338 24.3552 121.539 23.2128 121.374 22.0377L121.233 21.0336C121.232 21.0251 121.231 21.0175 121.23 21.0089L121.221 20.9468C121.217 20.9213 121.213 20.8962 121.208 20.871C121.207 20.8635 121.205 20.8559 121.204 20.8483C121.192 20.7723 121.181 20.6977 121.169 20.6243C120.997 19.4833 120.865 18.6147 118.942 16.9711L116.714 13.2411C116.646 13.1278 116.573 13.0162 116.493 12.9109L115.701 14.5284C115.747 14.5926 115.788 14.6639 115.826 14.7372L117.415 17.7616C117.559 18.0361 117.245 18.3509 116.938 18.3939C116.938 18.3939 115.438 18.4433 113.735 18.5456L109.484 27.2328Z",
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 53.4208,
    y: 18.9307,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(4 53.4208 18.9307)",
    fill: "#2F6FEB"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 53.4208,
    y: 18.9307,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(4 53.4208 18.9307)",
    stroke: "#E6EFFF",
    strokeWidth: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1396 33.002L67.8558 58.4182",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.5019 34.5288L80.8046 34.3402L74.4827 33.8982L70.6707 33.6316C69.8662 33.5754 69.3121 34.2508 68.9479 34.9703L66.5926 39.6219C64.3964 41.7815 64.3055 43.0655 64.2179 44.3024C64.2122 44.3827 64.2066 44.4629 64.2003 44.543C64.2 44.5477 64.1994 44.5523 64.1989 44.557C64.1984 44.5619 64.1978 44.5668 64.1974 44.5718L64.1901 44.6767L64.1052 45.8905C64.0079 47.2817 64.3276 48.6068 65.122 49.5805L64.85 53.471C64.8061 54.099 65.2762 54.6398 65.9042 54.6837L66.8495 54.7498C67.4775 54.7937 68.0183 54.3236 68.0622 53.6956L68.294 50.3813L70.9374 50.5661L78.2417 41.243C77.7993 41.194 77.3855 41.1548 77.0198 41.1295C74.3653 40.9461 69.0376 41.1522 69.0376 41.1522C68.6664 41.1265 68.2665 40.7766 68.4142 40.4351L70.0386 36.68C70.1863 36.3385 70.3845 36.0307 70.7557 36.0566L81.7051 36.8223L83.5019 34.5288Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.1601 50.7899L84.584 51.5188L84.3523 54.8331C84.3084 55.4611 84.7785 56.0019 85.4065 56.0458L86.3518 56.1119C86.9798 56.1559 87.5206 55.6857 87.5645 55.0577L87.8326 51.2235C88.7922 50.3698 89.3135 49.0792 89.4128 47.6586L89.4977 46.4448C89.4982 46.4344 89.4991 46.4253 89.4998 46.415L89.505 46.3398C89.5072 46.309 89.5079 46.2784 89.5087 46.2477C89.5089 46.2385 89.5092 46.2292 89.5094 46.22C89.5144 46.1278 89.5197 46.0374 89.525 45.9484C89.6068 44.5661 89.6691 43.5137 87.8219 41.1047L86.1373 36.1706C86.0862 36.0208 86.0275 35.8717 85.9602 35.7283L84.6274 37.4295C84.6647 37.516 84.6952 37.6097 84.722 37.7052L85.832 41.6515C85.9328 42.0097 85.4861 42.301 85.1149 42.2748C85.1149 42.2748 83.3422 41.9586 81.3179 41.6537L74.1601 50.7899Z",
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 124.421,
    y: 17.9327,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(4 124.421 17.9327)",
    fill: "#2F6FEB"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 124.421,
    y: 17.9327,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(4 124.421 17.9327)",
    stroke: "#E6EFFF",
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M159.14 32.0039L138.856 57.4201",
    stroke: "white",
    strokeWidth: 1.84615,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.502 33.5308L151.805 33.3422L145.483 32.9001L141.671 32.6336C140.866 32.5773 140.312 33.2528 139.948 33.9722L137.593 38.6238C135.396 40.7834 135.305 42.0674 135.218 43.3043C135.212 43.3847 135.207 43.4648 135.2 43.545C135.2 43.5497 135.199 43.5543 135.199 43.5589C135.198 43.5639 135.198 43.5688 135.197 43.5737L135.19 43.6787L135.105 44.8925C135.008 46.2837 135.328 47.6088 136.122 48.5824L135.85 52.473C135.806 53.101 136.276 53.6418 136.904 53.6857L137.85 53.7518C138.478 53.7957 139.018 53.3256 139.062 52.6976L139.294 49.3832L141.937 49.5681L149.242 40.2449C148.799 40.1959 148.386 40.1567 148.02 40.1315C145.365 39.9481 140.038 40.1542 140.038 40.1542C139.666 40.1284 139.266 39.7786 139.414 39.4371L141.039 35.682C141.186 35.3404 141.384 35.0326 141.756 35.0586L152.705 35.8242L154.502 33.5308Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.16 49.7918L155.584 50.5207L155.352 53.8351C155.308 54.4631 155.778 55.0039 156.406 55.0478L157.352 55.1139C157.98 55.1578 158.521 54.6877 158.565 54.0597L158.833 50.2254C159.792 49.3717 160.313 48.0811 160.413 46.6605L160.498 45.4467C160.498 45.4364 160.499 45.4272 160.5 45.4169L160.505 45.3418C160.507 45.3109 160.508 45.2803 160.509 45.2497C160.509 45.2404 160.509 45.2312 160.509 45.2219C160.514 45.1297 160.52 45.0394 160.525 44.9504C160.607 43.568 160.669 42.5156 158.822 40.1067L157.137 35.1726C157.086 35.0228 157.028 34.8737 156.96 34.7303L155.627 36.4314C155.665 36.518 155.695 36.6116 155.722 36.7071L156.832 40.6534C156.933 41.0116 156.486 41.303 156.115 41.2768C156.115 41.2768 154.342 40.9606 152.318 40.6557L145.16 49.7918Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectiveCarFreeDays);
export default __webpack_public_path__ + "static/media/collective-car-free-days.8606e6e4d355b78ec45c732946c2cb51.svg";
export { ForwardRef as ReactComponent };